import { render } from "./AddBank.vue?vue&type=template&id=277f066f&scoped=true"
import script from "./AddBank.vue?vue&type=script&lang=js"
export * from "./AddBank.vue?vue&type=script&lang=js"

import "./AddBank.vue?vue&type=style&index=0&id=277f066f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277f066f"]])

export default __exports__